
import { Transput } from "../Models/Platform/Transput";
import { HttpHelper } from "./HttpHelper"

export abstract class PlatformHelper{
    private static baseUrl = HttpHelper.GetUrlBaseApiPlatform() + "api/" + "Platform"
    public static async GetPlatformIdByType(): Promise<string> {
        var urlForRequest = this.baseUrl + "/platformIdFromPotline"
        return (await HttpHelper.GetRequestForApi<string>(urlForRequest))
    }

    public static async GetTransputs(platformId: string): Promise<Transput[]> {
        var urlForRequest = this.baseUrl + "/transputs/" + platformId;
        return (await HttpHelper.GetRequestForApi<Transput[]>(urlForRequest))
    }
}